import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import './circular-progress-bar.scss';

const CIRCLE_SIZE_VAL = 100;

const CircularProgressBar = ({
  className, strokeWidth, percentage, withMessage, withBackground,
}) => {
  const circleRadius = (CIRCLE_SIZE_VAL - strokeWidth) / 2;
  const circleCircumference = circleRadius * Math.PI * 2;
  const completedCircumference = circleCircumference - (circleCircumference * (percentage / 100));

  return (
    <svg
      className={clsx('circular-progress-bar', className)}
      viewBox={`0 0 ${CIRCLE_SIZE_VAL} ${CIRCLE_SIZE_VAL}`}
    >
      {withBackground
      && (
        <circle
          className="circle-progress-background"
          cx={CIRCLE_SIZE_VAL / 2}
          cy={CIRCLE_SIZE_VAL / 2}
          r={circleRadius}
          strokeWidth={`${strokeWidth}px`}
        />
      )}
      <circle
        className="circle-progress"
        cx={CIRCLE_SIZE_VAL / 2}
        cy={CIRCLE_SIZE_VAL / 2}
        r={circleRadius}
        strokeWidth={`${strokeWidth}px`}
        transform={`rotate(-90 ${CIRCLE_SIZE_VAL / 2} ${CIRCLE_SIZE_VAL / 2})`}
        style={{
          strokeDasharray: circleCircumference,
          strokeDashoffset: completedCircumference,
        }}
      />
      {withMessage
      && (
        <text
          className="circle-text"
          x="50%"
          y="50%"
          dy=".3em"
          textAnchor="middle"
        >
          {`${percentage}%`}
        </text>
      )}
    </svg>
  );
};

CircularProgressBar.propTypes = {
  className: PropTypes.string,
  withMessage: PropTypes.bool,
  percentage: PropTypes.number,
  strokeWidth: PropTypes.number,
  withBackground: PropTypes.bool,
};

CircularProgressBar.defaultProps = {
  className: '',
  strokeWidth: 5,
  percentage: 100,
  withMessage: true,
  withBackground: true,
};

export default CircularProgressBar;
